import Homehead from "@/Painting/home/home_head.vue";
import blankBottom from "@/components/base/blankBottom.vue";
export default {
  name: "about_us",
  emits: ["RouteEvent"],
  components: {
    Homehead,
    blankBottom
  },
  data() {
    return {
      index: 2
    };
  },
  watch: {
    $route(to, from) {
      // console.log(to, from);
    }
  },
  methods: {
    notifyChild() {
      // 触发自定义事件，并传递数据
      this.$emit('custom-event', 'Hello from parent!');
    }
  }
};